import XLSX from 'xlsx-js-style';

interface ExcelExportOptions {
  headerRow: string[];
  dataRows: (string | number)[][];
}

const useMonthlyXlsx = ({ headerRow, dataRows }: ExcelExportOptions) => {
  const handleClickExcelDownload = () => {
    const workbook = XLSX.utils.book_new();

    const data = [[{ v: '월별 검사 인원수' }], [...headerRow], ...dataRows];
    const worksheet = XLSX.utils.aoa_to_sheet(data);

    worksheet['!cols'] = Array.from({ length: data[0].length }, () => ({ wpx: 100 }));
    worksheet['A1'].s = { font: { bold: true, sz: 10, name: '맑은 고딕' } };

    for (let col = 0; col < data[1].length; col++) {
      const cellAddress = XLSX.utils.encode_cell({ r: 1, c: col });
      worksheet[cellAddress].s = {
        font: { bold: true, sz: 8, name: '맑은 고딕' },
        alignment: { horizontal: 'center', vertical: 'center' },
        fill: { fgColor: { rgb: 'e5e5e5' } },
        border: {
          top: { style: 'thin', color: { auto: 1 } },
          bottom: { style: 'thin', color: { auto: 1 } },
          left: { style: 'thin', color: { auto: 1 } },
          right: { style: 'thin', color: { auto: 1 } }
        }
      };

      for (let i = 2; i < data.length; i++) {
        const cellAddress = XLSX.utils.encode_cell({ r: i, c: col });

        const horizontal = col <= 1 ? 'center' : 'right';
        worksheet[cellAddress].s = {
          font: { sz: 8, name: '맑은 고딕' },
          alignment: { horizontal: horizontal, vertical: 'center' },
          fill: col < 1 && { fgColor: { rgb: 'e5e5e5' } },
          border: {
            top: { style: 'thin', color: { auto: 1 } },
            bottom: { style: 'thin', color: { auto: 1 } },
            left: { style: 'thin', color: { auto: 1 } },
            right: { style: 'thin', color: { auto: 1 } }
          }
        };
      }
    }

    XLSX.utils.book_append_sheet(workbook, worksheet, '월별 검사 인원수');
    XLSX.writeFile(workbook, '월별검사인원수.xlsx');
  };

  return { handleClickExcelDownload };
};

export default useMonthlyXlsx;
